import {
  Box,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Radio,
  Typography,
  CircularProgress,
  Button
} from "@mui/material";
import InvoiceAPI from "../../services/InvoiceService";
import { axiosPrivate } from "../../services/axios";
import { useEffect, useState } from "react";
import { getInvoiceFileName } from '../../utils/invoiceFilename';

export const SelectInvoiceTemplate = ({ row, onPdfBlobChange }) => {
  const [loading, setLoading] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);

  const [pdfBlob, setPdfBlob] = useState(null);
  const [pdfUrl, setPdfUrl] = useState("");

  useEffect(() => {
    if (pdfBlob) {
      const url = URL.createObjectURL(pdfBlob);
      setPdfUrl(url);
      return () => URL.revokeObjectURL(url);
    } else {
      setPdfUrl("");
    }
  }, [pdfBlob]);

  const getInvoiceTemplates = async () => {
    setLoading(true);
    try {
      const response = await InvoiceAPI.INVOICE_TEMPLATE_LIST(axiosPrivate);
      setTemplateList(response.data.results);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const generatePdfTemplate = async (template) => {
    if (!template || !template.id) {
      setSelectedTemplateId(null);
      setPdfBlob(null);
      if (typeof onPdfBlobChange === 'function') {
        onPdfBlobChange(null, null);
      }
      return;
    }
    setLoading(true);
    setSelectedTemplateId(template.id);
    setPdfBlob(null);
    try {
      const payload = {
        template: template.id,
        c2c_invoice_id: row.c2c_invoice_id
      };
      const response = await InvoiceAPI.GENERATE_INVOICE_PDF(
        axiosPrivate,
        payload
      );

      let blob = null;
      if (response && response.data) {
        if (response.data instanceof Blob) {
          blob = response.data;
        } else {
          blob = new Blob([response.data], { type: "application/pdf" });
        }
        setPdfBlob(blob);
        if (typeof onPdfBlobChange === 'function') {
          onPdfBlobChange(blob, template.id);
        }
      }
    } catch (error) {
      console.error("Error generating PDF:", error);
      setPdfBlob(null);
      if (typeof onPdfBlobChange === 'function') {
        onPdfBlobChange(null, template.id);
      }
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    getInvoiceTemplates();
  }, []);

  return (
    <Box>
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center">
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ mt: 2 }}>
          <Table sx={{ width: "100%", borderCollapse: "collapse", mt: 1 }}>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                <TableCell sx={{ width: 60, fontWeight: "bold" }}>#</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Template Name</TableCell>
                <TableCell
                  sx={{ width: 140, fontWeight: "bold", textAlign: "center" }}
                >
                  Select
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {templateList && templateList.length > 0 ? (
                templateList.map((template, idx) => (
                  <TableRow key={template.id}>
                    <TableCell align="center">{idx + 1}</TableCell>
                    <TableCell>{template.name}</TableCell>
                    <TableCell align="center">
                      <Radio
                        checked={selectedTemplateId === template.id}
                        onChange={() => {
                          generatePdfTemplate(template);
                        }}
                        value={template.id}
                        name="invoice-template"
                        inputProps={{
                          "aria-label": `Select template ${template.name}`
                        }}
                      />
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center" sx={{ py: 2 }}>
                    <Typography variant="body2" color="textSecondary">
                      No templates found.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          {pdfUrl && (
            <Box
              sx={{
                mt: 4,
                border: "1px solid #eee",
                borderRadius: 2,
                p: 2,
                height: 600,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch'
              }}
            >
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                PDF Preview
              </Typography>
              <iframe
                src={pdfUrl}
                title="PDF Preview"
                width="100%"
                height="100%"
                style={{ border: "none" }}
              />
              <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ width: 200 }}
                  onClick={() => {
                    const link = document.createElement('a');
                    link.href = pdfUrl;
                    let templateName = getInvoiceFileName(row);
                    link.download = templateName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                  disabled={!pdfUrl || !selectedTemplateId}
                >
                  Download PDF
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};
